import React, { Component } from 'react';
import VacationGateways from 'components/widgets/autocompletes/vacationGateways';
import VacationDestinations from 'components/widgets/autocompletes/vacationDestinations';
import HotelOccupancy from 'components/widgets/vacationTravellers';
import VacationDuration from 'components/widgets/vacationDurations';
import DayPicker from 'components/widgets/datePicker';
import ErrorHandler from 'libraries/errorHandler';
import ErrorTooltip from 'components/snippets/errorTooltip';
import buildQueryString from 'helpers/buildQueryString';
import Lang from 'libraries/Lang';
import moment from 'moment';
import CustomDatePicker from 'components/widgets/customDatePicker';
import LoadingModal from '../../../helpers/loadingModal';

class SunquestEngine extends Component {
    constructor(props) {
        super(props);
        const app = document.getElementById('app');

        moment.locale(window.Locale);

        const stateValue = {
            selectedDeparture: null,
            selectedDestination: null,
            duration: '7days,8days',
            startDate: null,
            occupancy: {
                rooms: 1, adults: 2, children: 0, ages: [],
            },
            occupancyOpen: false,
            shouldValidate: false,
            commonDateFormat: props.commonDateFormat,
            shouldValidateDepDate: false,
            shouldValidateCustomDate: false,
            loadingModel: false,
        };

        const rules = {
            'form.departure': (departure) => {
                let valid = true;

                if (departure === null || Object.keys(departure).length === 0) {
                    valid = Lang.trans('error.departure');
                }

                return valid;
            },
            'form.destination': (destination) => {
                let valid = true;

                if (destination === null || Object.keys(destination).length === 0) {
                    valid = Lang.trans('engine_travelgenie.select_a_destination');
                }

                return valid;
            },
            'occupancy.childAge': (age, key, index) => {
                let valid = true;

                if (age === '') {
                    valid = `child ${index + 1} needs an age`;
                }
                return valid;
            },
            'form.date': (date) => {
                let valid = true;
                if (date === null
                    || !moment(date, 'MM/DD/YYYY', true).isValid()
                    || !(moment(date, 'MM/DD/YYYY').isSameOrAfter(moment().format('MM/DD/YYYY')))) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_date');
                }
                if (valid == true) {
                    this.setState({ shouldValidateDepDate: false });
                } else {
                    this.setState({ shouldValidateDepDate: true });
                }
                return valid;
            },

            'occupancy.moreThenSix': (occupancy) => { // more then 6 passengers
                let valid = true;
                if ((parseInt(occupancy.adults, 10) + parseInt(occupancy.children, 10)) > 6) {
                    valid = Lang.trans('error_vacations.moreThenSix');
                }

                return valid;
            },
            'occupancy.adultsEven': (occupancy) => { // Adults need to be even
                let valid = true;
                if (parseInt(occupancy.adults, 10) % parseInt(occupancy.rooms, 10) > 1) {
                    valid = Lang.trans('error_vacations.adultsEven');
                }

                return valid;
            },
            'occupancy.multiRoomNoChildren': (occupancy) => {
                let valid = true;
                if (parseInt(occupancy.rooms, 10) > 1 && parseInt(occupancy.children, 10) > 0) {
                    valid = Lang.trans('error_vacations.multiRoomNoChildren');
                }

                return valid;
            },
        };

        this.errorHandler = new ErrorHandler(rules);

        // const storage = localStorage.getItem('sunquestEngine');

        // try {
        //     if (storage !== null && storage.length > 0) {
        //         Object.assign(stateValue, JSON.parse(storage));

        //         if (stateValue.startDate !== null) {
        //             stateValue.startDate = moment(stateValue.startDate);
        //             if (stateValue.startDate.isBefore(moment())) {
        //                 stateValue.startDate = moment();
        //             }
        //         }
        //     }
        // } catch (e) {
        //     localStorage.removeItem('sunquestEngine');
        // }

        this.state = stateValue;

        this.selectDestination = this.selectDestination.bind(this);
        this.onDurationChange = this.onDurationChange.bind(this);
        this.onOccupancyChange = this.onOccupancyChange.bind(this);
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.setOccupancy = this.setOccupancy.bind(this);
        this.handleOccupancyBlur = this.handleOccupancyBlur.bind(this);
        this.submit = this.submit.bind(this);
        this.onCustomDateChange = this.onCustomDateChange.bind(this);
        this.validateCustomDates = this.validateCustomDates.bind(this);
    }

    onDurationChange(event) {
        const { value } = event.target;

        this.setState({ duration: value });
    }

    selectDeparture(selectedDeparture) {
        this.setState({ selectedDeparture });
    }

    selectDestination(selectedDestination) {
        this.setState({ selectedDestination });
    }

    swapedLocations() {
        let { selectedDeparture, selectedDestination } = this.state;

        [selectedDeparture, selectedDestination] = [selectedDestination, selectedDeparture];

        this.setState({ selectedDeparture, selectedDestination });
    }

    onStartDateChange(startDate) {
        this.setState({ startDate });
    }

    validateCustomDates(name, depDate) {
        const { shouldValidate, commonDateFormat } = this.state;
        this.errorHandler.clear('form.date');

        if (name == 'depDate' && depDate != '') {
            this.errorHandler.checkRule('form.date', depDate);
        }
        this.setState({ shouldValidateCustomDate: true });
    }

    onCustomDateChange(startDate) {
        const dateMonth = startDate.replace(/[0-9]/g, '').toLowerCase();
        let updatedDate = startDate;
        const { language } = app.dataset;

        if (language == 'fr') {
            let lowerCaseDate = startDate.toLowerCase();
            if (dateMonth == 'jan') {
                updatedDate =  lowerCaseDate.replace('jan', 'janv');
            } else if (dateMonth == 'fev') {
                updatedDate =  lowerCaseDate.replace('fev', 'févr.');
            } else if (dateMonth == 'mar') {
                updatedDate =  lowerCaseDate.replace('mar', 'mars');
            } else if (dateMonth == 'avr') {
                updatedDate =  lowerCaseDate.replace('avr', 'avr.');
            } else if (dateMonth == 'mai') {
                updatedDate =  lowerCaseDate.replace('mai', 'mai');
            } else if (dateMonth == 'jun') {
                updatedDate =  lowerCaseDate.replace('jun', 'juin');
            } else if (dateMonth == 'jul') {
                updatedDate =  lowerCaseDate.replace('jul', 'juil');
            }  else if (dateMonth == 'aou') {
                updatedDate =  lowerCaseDate.replace('aou', 'août');
            }  else if (dateMonth == 'sep') {
                updatedDate =  lowerCaseDate.replace('sep', 'sept');
            }  else if (dateMonth == 'oct') {
                updatedDate =  lowerCaseDate.replace('oct', 'oct.');
            }  else if (dateMonth == 'nov') {
                updatedDate =  lowerCaseDate.replace('nov', 'nov.');
            }  else if (dateMonth == 'dec') {
                updatedDate =  lowerCaseDate.replace('dec', 'déc.');
            }  
        }

        const { shouldValidateDepDate } = this.state;
        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.date');
        }
        updatedDate = moment(updatedDate, this.state.commonDateFormat, true).isValid() ? moment(updatedDate, 'DD-MMM-YYYY') : updatedDate;

        this.setState({ startDate: updatedDate }, () => {
            const { depDate, retDate } = this.state;
            this.errorHandler.checkRule('form.dates', { depDate, retDate });
        });
    }

    handleOccupancyBlur(event) {
        let node = event.target;

        let within = false;

        while (node !== event.currentTarget) {
            node = node.parentNode;

            if (node.classList.contains('htl_popover')) {
                within = true;
                break;
            }
        }

        if (!within) {
            this.hideOccupancy();
        }
    }

    onDurationChange(duration) {
        this.setState({ duration });
    }

    onStartDateChange(startDate) {
        const { shouldValidate } = this.state;

        this.setState({ startDate });

        if (shouldValidate) {
            this.errorHandler.checkRule('form.date', startDate);
        }
    }

    onDatesChange(depDate, retDate) {
        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.dates', { depDate, retDate });
        }
        this.setState({ depDate, retDate });
    }

    onOccupancyChange(occupancy) {
        const { shouldValidate } = this.state;

        this.setState({ occupancy });

        if (shouldValidate) {
            this.errorHandler.checkRule('occupancy.moreThenSix', occupancy);
            this.errorHandler.checkRule('occupancy.adultsEven', occupancy);
            this.errorHandler.checkRule('occupancy.multiRoomNoChildren', occupancy);
            occupancy.ages.forEach((age) => {
                this.errorHandler.checkRule(`occupancy.childAge-${index}`, age);
            });
        }
    }

    setOccupancy(occupancyOpen) {
        if (occupancyOpen) {
            this.showOccupancy();
        } else {
            this.hideOccupancy();
        }
    }

    hideOccupancy() {
        const app = document.getElementById('page');
        app.removeEventListener('click', this.handleOccupancyBlur);

        this.setState({ occupancyOpen: false });
    }

    showOccupancy() {
        const app = document.getElementById('page');
        app.addEventListener('click', this.handleOccupancyBlur);

        this.setState({ occupancyOpen: true });
    }

    selectDestination(selectedDestination) {
        const { shouldValidate } = this.state;

        this.setState({ selectedDestination });

        if (shouldValidate) {
            this.errorHandler.checkRule('form.destination', selectedDestination);
        }
    }

    selectDeparture(selectedDeparture) {
        const { shouldValidate } = this.state;

        this.setState({ selectedDeparture });

        if (shouldValidate) {
            this.errorHandler.checkRule('form.departure', selectedDeparture);
        }
    }

    submit(event) {
        event.preventDefault();
        const {
            selectedDeparture,
            selectedDestination,
            duration,
            startDate,
            occupancy,
        } = this.state;

        this.errorHandler.checkRule('form.departure', selectedDeparture);
        this.errorHandler.checkRule('form.destination', selectedDestination);
        this.errorHandler.checkRule('form.date', startDate);
        this.errorHandler.checkRule('occupancy.moreThenSix', occupancy);
        this.errorHandler.checkRule('occupancy.adultsEven', occupancy);
        this.errorHandler.checkRule('occupancy.multiRoomNoChildren', occupancy);
        occupancy.ages.forEach((age, index) => {
            this.errorHandler.checkRule(`occupancy.childAge-${index}`, age);
        });

        const errors = this.errorHandler.getErrors();
        const errorKeys = Object.keys(errors);
        if (errorKeys.length > 0) {
            event.preventDefault();
            this.setState({ shouldValidate: true });
            errorKeys.forEach((key) => {
                if (key.indexOf('occupancy') !== -1) {
                    this.showOccupancy();
                }
            });
        } else {
            this.setState({ loadingModel : true });

            const params = {
                dest_dep: selectedDestination.destinations,
                sentdest: selectedDestination.text,
                gateway_dep: selectedDeparture.value,
                remember_dep: selectedDeparture.text,
                date: startDate.format('YYYYMMDD'),
                duration,
                numberOfRooms: occupancy.rooms,
                numberOfAdults: occupancy.adults,
                numberOfChildren: occupancy.children,
                all_inclusive: '',
                child: occupancy.ages,
                date_format: 'Ymd',
                hotel_no: selectedDestination.hotels,
                alias: 'engine',
                sentalias: 'api',
                selectedProducts: 'S',
            };

            // const queryString = buildQueryString(params);

            // console.log(queryString);

            const queryString = JSON.stringify(params);
            const encodeUrl = encodeURI(queryString);

            window.location.href = `/launch/sunquest?search=${encodeUrl}`;
            // window.location.href = `https://secure.redtag.ca/res/vacations/search?${queryString}`;

            const storage = {
                selectedDeparture,
                selectedDestination,
                duration,
                startDate,
                // depDate,
                // retDate,
                occupancy,
            };

            localStorage.setItem('sunquestEngine', JSON.stringify(storage));

            // const url = TravelRedirect+"/?t=" + Traveltoken;
            // window.location.href = url;
        }
    }

    render() {
        const {
            selectedDeparture,
            selectedDestination,
            duration,
            startDate,
            occupancy,
            occupancyOpen,
            commonDateFormat,
            shouldValidateDepDate,
            loadingModel
        } = this.state;
console.log("this.state------------------",this.state);
        const errors = this.errorHandler.getErrors();

        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.date');
        }

        const isStartDateValid = moment(startDate, commonDateFormat, true).isValid();

        return (
            <>
            <LoadingModal isLoading={loadingModel} /> 
            <form className="search-sunquest pt-1" onSubmit={this.submit}>
                <input type="hidden" name="dest_dep" value="" />
                <div className="row gutter-10 mb-md-2">
                    <div className="col-12 col-md-12 col-lg-12 col-xl-5 going-to">                        
                            <div className="row gutter-10">
                                <div className="col-12 col-sm-6">
                                    <div className="element-container">
                                        <label className="text-label" htmlFor="squ_gateway">{Lang.trans('engine_travelgenie.from')}</label>
                                        <div className="element-wrapper">
                                            <VacationGateways
                                                id="squ_gateway"
                                                placeholder={Lang.trans('engine_sunquest.destination_placeholder')}
                                                onSelect={(value) => this.selectDeparture(value)}
                                                value={selectedDeparture}
                                            />
                                            {errors.form && errors.form.departure && (
                                                <ErrorTooltip error={{ message: errors.form.departure, id: 'squ_gateway' }} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="element-container">
                                            <label className="text-label" htmlFor="squ_destination">{Lang.trans('engine_travelgenie.to')}</label>
                                            <div className="element-wrapper">
                                            <VacationDestinations
                                                id="squ_destination"
                                                placeholder={Lang.trans('engine_sunquest.destination_placeholder')}
                                                value={selectedDestination}
                                                gateway={(selectedDeparture !== null ? selectedDeparture.value : 'YYZ,YTZ')}
                                                onSelect={(value) => this.selectDestination(value)}
                                            />
                                            {errors.form && errors.form.destination && (
                                                <ErrorTooltip error={{ message: errors.form.destination, id: 'squ_destination' }} />
                                            )}
                                        </div>
                                    </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-2">
                        <div className="element-container">
                            <div className="row gutter-0">
                                <div className="col">
                                    <div className="cldr_container single-date-picker">
                                        {/* <DayPicker
                                            dateId="departureDate"
                                            onDateChange={ (startDate) => this.onStartDateChange(startDate) }
                                            minDate={1}
                                            label="Departure"
                                            datePlaceholderText="Select Date"
                                            date={startDate}
                                        /> */}
                                        <CustomDatePicker
                                            // onDatesChange={this.onDatesChange}
                                            onCustomDateChange={this.onCustomDateChange}
                                            dateId="departureDate"
                                            onDateChange={this.onStartDateChange}
                                            minDate={1}
                                            label={Lang.trans('engine_travelgenie.departure')}
                                            datePlaceholderText={Lang.trans('engine.date_format')}
                                            date={startDate}
                                            isStartDateValid={isStartDateValid}
                                            dateFormat={commonDateFormat}
                                            validateCustomDates={this.validateCustomDates}
                                        />
                                        {errors.form && errors.form.date && (
                                            <ErrorTooltip error={{ message: errors.form.date, id: 'departureDate' }} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-2">
                        <div className="element-container select-unstyled-container">
                            <label className="text-label" htmlFor="">{Lang.trans('engine_sunquest.howLong')}</label>
                            <VacationDuration
                                durations={selectedDestination !== null ? selectedDestination.durations.split(',') : ['']}
                                value={duration}
                                onChange={this.onDurationChange}
                            />
                            <svg className="icon icon-select" aria-hidden="true">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                            </svg>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-3 room-guest">
                        <div className="element-container mb-lg-0">
                            <HotelOccupancy
                                visible={occupancyOpen}
                                travellers={occupancy}
                                errors={errors.occupancy}
                                validateField={() => { }}
                                onChange={this.onOccupancyChange}
                                onVisibilityChange={this.setOccupancy}
                            />
                        </div>
                    </div>
                </div>
                <div className="row gutter-10 border-top pt-2 align-items-center">
                    <div className="col-12 text-center mt-2">
                        <button type="submit" className="btn btn-primary btn-lg px-5 font-weight-600">
                            <span className="">{Lang.trans('buttons.search')}</span>
                        </button>
                    </div>
                </div>
            </form>
            </>
        );
    }
}

export default SunquestEngine;
